import commonLogoutMixin from '@shared_mixins/common-logout-mixin';

export default {
    // name: 'common-error-handling-mixin',
    mixins: [
        commonLogoutMixin
    ],
    data: () => ({}),
    created () {},
    mounted () {},
    methods: {
        async common_error_handling (error, cb) {
            if (process.env.NODE_ENV === 'development') {
                console.log(`common_error_handling ~ `);
                
                console.log(` ~ error => `, error);
                if (error.response) {
                    console.log(` ~ error.response => `, error.response);
                }
            }
            
            if (error && error.response && error.response.status === 401) {
                await this.common_401_error_handling()
            }

            if (cb) {
                await cb(error)
            }
        },
        // 경고창 없이 로그인 화면으로 — 사유는 로그인 화면이 reason=session 으로 안내한다
        async common_401_error_handling() {
            await this.commonLogout()
        }
    }
}